import type { ReactNode } from 'react';

export function PageHeader({
  title,
  subtitle,
  actions,
  clause,
}: {
  title: string;
  subtitle?: string;
  actions?: ReactNode;
  /** AS9100D madde no (denetim referansı için başlıkta gösterilir). */
  clause?: string;
}) {
  return (
    <div className="mb-6 flex flex-col gap-3 sm:flex-row sm:items-end sm:justify-between">
      <div>
        <h1 className="text-xl font-semibold tracking-tight text-slate-900 dark:text-slate-100">
          {title}
        </h1>
        {subtitle && (
          <p className="mt-1 text-sm text-slate-500 dark:text-slate-400">{subtitle}</p>
        )}
        {clause && (
          <p className="mt-1 text-xs text-slate-400 dark:text-slate-500">
            AS9100D Madde: {clause}
          </p>
        )}
      </div>
      {actions && <div className="flex shrink-0 items-center gap-2">{actions}</div>}
    </div>
  );
}
